import { useEffect, useState } from 'react';
import { api, getSession } from '../api/client.ts';
import type { Periode } from './Accueil.tsx';

interface LignePeriode extends Periode {
  nb_consultations: number;
  derniere_synchro: string | null;
}

export default function Historique({ onOuvrir }: { onOuvrir: (p: Periode) => void }) {
  const [lignes, setLignes] = useState<LignePeriode[]>([]);
  const session = getSession();

  useEffect(() => {
    if (session.csbId) {
      api.get<LignePeriode[]>(`/rma/historique/${session.csbId}`).then(setLignes);
    }
  }, []);

  const parAnnee = lignes.reduce<Record<number, LignePeriode[]>>((acc, l) => {
    (acc[l.annee] ??= []).push(l);
    return acc;
  }, {});

  const MOIS = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

  return (
    <div>
      <h1>Historique</h1>
      {Object.entries(parAnnee).sort((a, b) => Number(b[0]) - Number(a[0])).map(([annee, ps]) => (
        <div key={annee}>
          <h2>{annee}</h2>
          <table>
            <thead><tr><th>Mois</th><th>Consultations</th><th>Statut</th><th>Dernière synchro</th><th></th></tr></thead>
            <tbody>
              {ps.sort((a, b) => a.mois - b.mois).map((p) => (
                <tr key={p.id}>
                  <td>{MOIS[p.mois - 1]}</td>
                  <td>{p.nb_consultations}</td>
                  <td>{p.statut}</td>
                  <td>{p.derniere_synchro ? new Date(p.derniere_synchro).toLocaleString('fr-FR') : '—'}</td>
                  <td><button className="secondaire" onClick={() => onOuvrir(p)}>Ouvrir</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
      {lignes.length === 0 && <p>Aucune période enregistrée pour le moment.</p>}
    </div>
  );
}
